import { Component, Input } from '@angular/core';

@Component({
    selector: 'api-error',
    template: `
        <ngb-alert type="danger" *ngIf="apiError.hasError"
                   (close)="apiError.hasError=false">{{ apiError.errorMessage }}
        </ngb-alert>
    `
})

/**
 * Shared API error component which shows when the API returns an error
 */
export class ApiErrorComponent {
    @Input() apiError: any;
}

